// Values of this enum used for filtering must be equal to the corresponging attribute name in the Commerce tools
// the same values must be also used for translation keys inside the Contentful
// TODO: Maybe refactor 'isSellable' so it uses the same notation as the rest of attributes
enum ProductAttributes {
  mainCategory = 'main-category',
  culture = 'culture',
  hairType = 'type-de-cheveux',
  typeOfSkins = 'type-de-peaux',
  olfactoryUniverse = 'univers-olfactif',
  suitableFor = 'adapte-pour',
  properties = 'proprietes',
  beautyProperties = 'proprietes-beaute',
  wellnessProperties = 'proprietes-bien-etre',
  issues = 'problematiques',
  beautyProblems = 'problematiques-beaute',
  homeProblems = 'problematiques-maison',
  wellnessProblems = 'problematiques-bien-etre',
  kitchenProblems = 'problematiques-cuisine',
  isSellable = 'isSellable',
  availableInCountries = 'available-in-countries',
  price = 'price',
  bestSeller = 'best-seller',
  isNew = 'is-new-product',
  workshop = 'ATELIER',
}

enum ProductKeys {
  inStock = 'InStock',
  outOfStock = 'OutOfStock',
  lowStock = 'lowStock',
  stockAvailableDays = 'stockAvailableDays',
  discontinued = 'discontinued',
  isSellable = 'is-sellable',
  isProductDiscontinued = 'is-product-discontinued',
  isDiscontinued = 'isDiscontinued',
  isComplimentary = 'is-complimentary',
  color = 'color',
  capacity = 'capacity',
  capacityUnit = 'capacity-unit',
  capacityType = 'capacity-type',
  isNewProduct = 'is-new-product',
  notAvailable = 'NotAvailable',
  ecoPart = 'eco-part',
}

export { ProductAttributes, ProductKeys };
